import {
  validateFormat,
  validatePresence,
} from 'ember-changeset-validations/validators';

export default {
  title: [
    validatePresence(true),
    validateFormat({ type: 'string', allowBlank: false }),
  ],
  color: [
    validatePresence(true),
    validateFormat({ type: 'string', allowBlank: false }),
  ],
};
